import React from 'react';
import './StorylaneDemoEmbed.scss';

interface Props {
  demoUrl: string;
}

const StorylaneDemoEmbed = React.memo(({ demoUrl }: Props) => {
  return (
    <div className="storylane-demo-embed">
      <div className="storylane-demo-embed__container">
        <iframe
          loading="lazy"
          src={demoUrl}
          allow="fullscreen"
          sandbox="allow-scripts allow-same-origin allow-popups allow-forms"
          title="Interactive Demo"
          className="storylane-demo-embed__iframe"
        ></iframe>
      </div>
    </div>
  );
});

export default StorylaneDemoEmbed;
